import { Control, Controller } from 'react-hook-form';
import { ToggleSwitch } from '@/components';

interface FormToggleSwitchProps {
  name: string;
  control: Control<any>;
  ariaLabel?: string;
  onChange?: (checked: boolean) => void;
}

const FormToggleSwitch = ({
  name,
  control,
  ariaLabel,
  onChange,
}: FormToggleSwitchProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <ToggleSwitch
          checked={field.value}
          ariaLabel={ariaLabel}
          onChange={(checked) => {
            onChange?.(checked);
            field.onChange(checked);
          }}
        />
      )}
    />
  );
};

export default FormToggleSwitch;
